module.exports = __webpack_public_path__ + "static/media/on3.f1c6f41c.png";